import axios from 'axios';
import store from '@/store/index.js';
import { AUTH_LOGOUT, AUTH_REFRESH } from '@/store/mutationTypes.js';
import { GLOBAL_TIMEOUT } from '@/settings.js';
import {
  createErrorMessage,
  showErrors,
  showMessage,
} from '@/utils/messages.js';

//let baseURL = 'http://localhost:5000';
let baseURL = 'http://api.allteams.space:80/';
// здесь существительное request говорит о том, что хранится в переменной
let refreshTokenRequest = null;

switch (process.env.NODE_ENV) {
  case 'development':
    baseURL = 'http://localhost:5000';
	//baseURL = 'http://api.allteams.space:80/';
    break;
  case 'staging':
    //baseURL = 'http://tavern.fuse8.online:80/';
    baseURL = 'https://api.staging.allteams.space:443/';
    break;
  case 'production':
  default:
    baseURL = 'https://api.allteams.space:443/';
    break;
}

const apiClient = axios.create({
  baseURL,
  // ошибки со статусом кода меньше 500 обрабатываем на фронте
  validateStatus: (status) => status < 500,
  timeout: GLOBAL_TIMEOUT,
});

// здесь глагол request указывает на асинхронность метода
async function requestValidAccessToken(config) {
  let { accessToken } = store.state.user;
  // кастомный проп конфига, поддерживается не всеми версиями axios, следить за версией
  const { isAuthCheckSkipped } = config;
  // timestamp
  const now = Math.floor(Date.now() * 0.001);

  // проверяем, не нужно ли обновить токены, во всех запросах, кроме логина и рефреша токенов
  if (!isAuthCheckSkipped) {
    if (!store.getters.isRefreshTokenValid(now)) {
      store.commit(AUTH_LOGOUT);
    } else if (!store.getters.isAccessTokenValid(now)) {
      // если не было запроса на обновление
      // создаем запрос и запоминаем его в переменную
      // для избежания race condition
      if (refreshTokenRequest === null) {
        refreshTokenRequest = store.dispatch(AUTH_REFRESH);
      }

      // ждем обновления токенов. Заголовки axios пропатчатся в модуле vuex user
      accessToken = await refreshTokenRequest;

      // очищаем переменную
      refreshTokenRequest = null;
    }
  }

  return accessToken;
}

// поведение перед отправкой запроса
apiClient.interceptors.request.use(async (config) => {
  const accessToken = await requestValidAccessToken(config);

  return {
    ...config,
    headers: {
      common: {
        ['Authorization']: `Bearer ${accessToken}`,
      },
    },
  };
});

// поведение перед обработкой ответа
apiClient.interceptors.response.use(
  // сюда попадает все, что валидируется успешным ответом status < 500
  (response) => {
    const {
      data: { errors },
      config: { isErrorsSkipped, generalErrorsOnly },
      status,
    } = response;

    // если пришла 401, разлогиниваем пользователя
    // TODO отвязаться от 401 статуса
    if (status === 401) {
      store.commit(AUTH_LOGOUT);
    } else if (errors) {
      if (generalErrorsOnly) {
        // показываем общие ошибки
        // в формах, где ошибки для полей выводятся в полях
        if (errors.some((error) => error.propertyName === 'GeneralErrors')) {
          showErrors(errors);
        }
      } else if (!isErrorsSkipped) {
        // показываем ошибки сервера для фронта, если нет указаний пропустить их вывод
        showErrors(errors);
      }
    }

    return response;
  },
  (error) => {
    const { code, config } = error;

    if (code === 'ECONNABORTED' /* или ошибка таймаута сервера */) {
      const { isErrorsSkipped } = config;
      const errorMessage = `No response from the server. Please try again later.`;

      if (!isErrorsSkipped) {
        showMessage({ message: errorMessage, type: 'error' });
      }

      // резолвимся с success false и сообщением об ошибке
      return Promise.resolve({
        data: {},
        success: false,
        ...createErrorMessage(errorMessage),
      });
    }

    return Promise.reject(error);
  },
);

// все методы принимают объект единственным параметром
export { apiClient, baseURL };
